/**
 * AttachmentModalContent Component
 * Displays attachment content based on file type (PDF, image, video)
 */
import { getFileType } from '../utils/fileUtils'
import '../styles/AttachmentModalContent.css'

export default function AttachmentModalContent({ attachment }) {
  if (!attachment) return null

  const fileType = getFileType(attachment.name)

  return (
    <div className="attachment-modal-content">
      {fileType === 'pdf' && attachment.url ? (
        <iframe
          src={attachment.url}
          title={attachment.name}
          className="attachment-modal-iframe"
        />
      ) : fileType === 'image' && attachment.url ? (
        <img
          src={attachment.url}
          alt={attachment.name}
          className="attachment-modal-image"
        />
      ) : fileType === 'video' && attachment.url ? (
        <video
          src={attachment.url}
          controls
          className="attachment-modal-video"
        />
      ) : (
        <div className="attachment-modal-no-preview">
          <div className="attachment-modal-no-preview-icon">
            📄
          </div>
          <p className="attachment-modal-no-preview-text">
            Preview not available for this file type
          </p>
          <p className="attachment-modal-no-preview-name">
            {attachment.name}
          </p>
        </div>
      )}
    </div>
  )
}
